import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Toolbar,
  Grid,
  Button,
  GridList,
  GridListTile,
  Paper,
  Card,
  CardMedia,
  CardContent
} from '@material-ui/core';
import StorageIcon from '@material-ui/icons/Storage';
import Typography from '@material-ui/core/Typography';
import {
  closetImageHeight,
  imagePaddingString
} from '../../constants/general';
import '../../assets/stylesheets/Closet.css';
import i18n from '../../i18n';
import ProductDetailsModal from './ProductDetailsModal'

class ProductGridList extends Component {
    constructor(props) {
      super(props);
  
      this.state = {
        page: 1,
        selectedProduct: null   
      }
    }

    handleClickOpen = (product) => {
        this.setState({ selectedProduct: product });
    }

    closeDetails = () => {
        this.setState({ selectedProduct: null });  
    }

    loadMore = () => {
      return this.setState((prevState) => ({
        page: prevState.page + 1
      }), () => this.retrieveProducts());     
    };

    retrieveProducts = () => {
      const { page } = this.state;
      const { getProducts } = this.props;
      return getProducts(page);
    }

    buildHostName = () => {
      const isDev = window.config.nodeEnv === 'development';
      const protocol = isDev ? 'http://' : 'https://';
      const host = isDev ? `${window.config.url.exposedHost}:${window.config.url.exposedPort}` : window.config.url.exposedHost;
      return `${protocol}${host}`;
    }

    addPadding = (imgUrl) => {
        return imgUrl.replace('__IMAGE_PARAMS__', imagePaddingString)
    };

    imageIsDefined = (firstImageItem) => {
      return firstImageItem !== undefined && (firstImageItem.image !== undefined && firstImageItem.image !== '');
    }

    printImage(product){
      return this.imageIsDefined(product.images[0]) ? this.addPadding(product.images[0].image)
             : `${this.buildHostName()}/NoBuyingImage.png`;      
    }

    render() {
        
        const { productsLoaded, pagination, openCart } = this.props;
        const { selectedProduct } = this.state;
        
        return (
          <Paper elevation={0} className="innerPaperContainer">
            <Toolbar>
              <StorageIcon />
              <Typography className="title" variant="h6" noWrap>
                {i18n.t('productListing:productsListing')}
              </Typography>   
            </Toolbar>
            <GridList cols={4} spacing={1}>
              {productsLoaded.map((product) => (
                <GridListTile 
                  key={product.id} 
                  cols={1} 
                  onClick={() => this.handleClickOpen(product)}
                  className="itemTitle"
                >
                  <Card elevation={0} className='card'>
                    <CardMedia
                      component='img'
                      className='cardMedia'
                      image={this.printImage(product)}
                      height={`${closetImageHeight}px`}
                      title={product.name}
                    />
                    <CardContent className='cardContent'>
                      <Typography gutterBottom variant="h5" component="h2">
                        {product.brand[0].name}
                      </Typography>
                      <Typography gutterBottom variant="h5" component="h2">
                        {product.name}
                      </Typography>
                    </CardContent> 
                  </Card>
                </GridListTile>
              ))}
            </GridList>
            <Paper elevation={1}>
              <Grid 
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justify="center"
              >
                {(pagination.page < pagination.total_pages) && (
                <Button className="ssenseButton ssensePrimary" variant="contained" onClick={this.loadMore}>
                    {i18n.t('productListing:loadMore')}
                </Button>)}
              </Grid>
            </Paper>
            <ProductDetailsModal
              showModal={selectedProduct !== null}
              onClose={this.closeDetails}
              product={selectedProduct}    
              openCart={openCart}    
            />      
          </Paper>
        );
    }
}

ProductGridList.propTypes = {
  productsLoaded: PropTypes.arrayOf(PropTypes.object).isRequired,
  pagination: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  getProducts: PropTypes.func.isRequired,
  openCart: PropTypes.func.isRequired,
}

export default ProductGridList;